import FeatherIcon from 'feather-icons-react';
import { Card, Col, Row, Spinner } from 'react-bootstrap';

import { currencyFormatter } from '../helpers/currencyFormatter';
import { PendingOrdersMetric } from '../types/dashboard';

const KPI_CARD_MIN_HEIGHT = 92;

interface AnalyticsAverageTimeProps {
  data?: PendingOrdersMetric;
  isLoading?: boolean;
}

export default function AnalyticsAverageTime({ data, isLoading, ...props }: AnalyticsAverageTimeProps) {
  const hasData = !isLoading && data !== undefined;

  return (
    <Card {...props}>
      <Card.Body style={{ minHeight: KPI_CARD_MIN_HEIGHT }}>
        <Row className="align-items-center h-100">
          <Col>
            <h6 className="text-uppercase text-muted mb-2">Pending Orders</h6>
            {isLoading ? (
              <Spinner animation="border" size="sm" />
            ) : hasData ? (
              <>
                <span className="h2 mb-0">{data.value}</span>
                <span className="text-muted ms-2 small">({currencyFormatter(data.totalAmount)})</span>
              </>
            ) : (
              <span className="h2 mb-0 text-muted">No data available</span>
            )}
          </Col>
          <Col xs="auto">
            <FeatherIcon icon="shopping-cart" size="20" className="text-muted" />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
